export { addSuportedLocaleData, getLanguageFromLocale } from './locale-data';
